import { Controller } from "@hotwired/stimulus";

// GR-1981 — the event log composer bar: a collapsed single-line row that grows
// into the full compose box on focus.
export class EventLogComposerController extends Controller {
  static targets = ["input"];

  expand() {
    this.element.classList.add("is-expanded");
    this.inputTarget.focus();
  }
}
